import { Button } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import React, { useState } from "react";
import MailClient from "./mailclient";

function Enquiry() {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      {/* Inline style block for pulse animation */}
      <style>{`
        @keyframes pulse {
          0% {
            box-shadow: 0 0 0 0 rgba(255, 193, 7, 0.7);
          }
          70% {
            box-shadow: 0 0 0 10px rgba(255, 193, 7, 0);
          }
          100% {
            box-shadow: 0 0 0 0 rgba(255, 193, 7, 0);
          }
        }

        .talk-to-us-btn {
          background-color: #ffc107;
          color: white;
          border: none;
          font-weight: bold;
          padding: 10px 20px;
          border-radius: 50px;
          animation: pulse 1.5s infinite;
        }

        .talk-to-us-btn:hover {
          background-color: #e0a800;
          transform: scale(1.05);
        }
      `}</style>

      <Button className="talk-to-us-btn" onClick={handleShow}>
        Talk to Us !!
      </Button>

      <Modal show={show} onHide={handleClose} animation={true}>
        <Modal.Header closeButton>
          <Modal.Title>Callback Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <MailClient />
        </Modal.Body>
        <Modal.Footer>
          <Button
            style={{ display: "block", margin: "auto" }}
            variant="secondary"
            onClick={handleClose}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Enquiry;
